import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useInviteDialogStore = defineStore('inviteDialog', () => {
  const isInviteDialogOpen = ref(false)

  return {
    isInviteDialogOpen
  }
})
